import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Select from "react-select";
import {Button, Col, Form, Row} from "react-bootstrap";
import {deleteUser, listUsers, logout, updatePretendUser} from "../actions/userActions";
import Message from "../components/Message";
import Loader from "../components/Loader";
import {USER_DELETE_RESET} from "../constants/userConstants";

const AdminDeleteUserScreen = ({history, language, t}) => {

    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;
    const dispatch = useDispatch();

    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const userList = useSelector((state) => state.userList);
    const userDelete = useSelector((state) => state.userDelete);
    const {loading, users, error} = userList;
    const {loading: deleteLoading, success} = userDelete;

    useEffect(() => {
        if (!userInfo || !userInfo.isAdmin) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(() => {
        dispatch(listUsers());
    },[dispatch]);

    useEffect(()=>{
        if(users?.length > 0){
            const moddedUsers = users.map(user => {
                user.label = user.name + ' - ' + user.email + `\n(${user.folder})`;
                user.value = user.email;
                return user;
            });

            const idx = moddedUsers.findIndex((user) => user._id === userInfo._id);
            moddedUsers.splice(idx, 1);


            setUserOptions(moddedUsers);
            setSelectedUser(null);
        }
        else {
            dispatch({type: USER_DELETE_RESET});
        }
    }, [users])

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);


    const onUserChanged = (userFromSelect) => {
        setSelectedUser(userFromSelect);
        console.log(userFromSelect);
    }

    const submitDelete = async (e) => {
        e.preventDefault();
        if(selectedUser !== null && selectedUser !== undefined && selectedUser._id !== null && selectedUser._id !== undefined){
            await dispatch(deleteUser(selectedUser._id));
        }
    };


    return (
        <>
            <h1>
                {t('admin_delete_user_title')}
            </h1>
            {loading && <Loader/>}
            <Form onSubmit={submitDelete}>
                <Row className='mb-3'>
                    <Col><Select options={userOptions} onChange={onUserChanged} value={selectedUser} placeholder={'Felhasználó'}/></Col>
                </Row>
                <Row className='mb-3'>
                    <Col></Col>
                    <Col>
                        <div className={' text-center mb-3'}><Button type='submit'
                                                                         variant='danger'>{t('button_delete')}</Button></div>
                    </Col>
                    <Col></Col>
                </Row>

                {error ? <Message variant='danger'>{error}</Message> : null}
                {success &&
                    <Message variant='success'>
                        {'Felhasználó törölve'}
                    </Message>
                }
            </Form>

        </>
    );
};

export default AdminDeleteUserScreen;
